import Box from "@mui/material/Box";
import AcceptButton from "./AcceptButton";
import RejectButton from "./RejectButton";

export const getColumns = (t) => {
	return [
		{
			label: t("company_name_label"),
			name: "name",
		},
		{
			label: t("nip_label"),
			name: "nip",
		},
		{
			label: t("first_name_label"),
			name: "registeredBy",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value) {
						return value.firstName;
					}
					return "-";
				},
			},
		},
		{
			label: t("surname_label"),
			name: "registeredBy",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value) {
						return value.lastName;
					}
					return "-";
				},
			},
		},
		{
			label: t("email_label"),
			name: "registeredBy",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value) {
						return value.email;
					}
					return "-";
				},
			},
		},
		{
			label: t("phone_label"),
			name: "registeredBy",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value) {
						return value.phone_number;
					}
					return "-";
				},
			},
		},
		{
			label: t("date"),
			name: "created_at",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value) {
						const parsedDate = new Date(value).toLocaleDateString("pl-PL", {
							day: "numeric",
							month: "long",
							year: "numeric",
						});
						const parsedTime = new Date(value).toLocaleTimeString("pl-PL");

						return parsedDate + " " + parsedTime;
					}
					return "-";
				},
			},
		},
		{
			label: t("actions"),
			name: "id",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const rowData = tableMeta.rowData;
					const name = rowData[1];

					return (
						<Box sx={{ display: "flex", gap: "6px", justifyContent: "center" }}>
							<RejectButton companyId={value} companyName={name} />
							<AcceptButton companyId={value} companyName={name} />
						</Box>
					);
				},
			},
		},
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		selectableRows: "none",
		print: false,
		filter: false,
		download: true,
		viewColumns: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
